import { Radio, RadioGroup, Spacer, Stack, Text, useColorMode } from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import { useController } from 'react-hook-form';
import { FormControl, FormHelperText, FormLabel, FormWarning } from '../..';
export const FormRadio = ({ name, control, labelText, register, helperText, options, groupProps, rules, ...rest }) => {
    const { field: { onChange, onBlur, value, ref }, formState: { errors } } = useController({
        control,
        name,
        rules: rules
    });
    const { colorMode } = useColorMode();
    return (React.createElement(FormControl, { key: 'radio-box-' + name },
        labelText && (React.createElement(FormLabel, { htmlFor: name, key: 'radio-label-' + name },
            React.createElement(Text, { key: 'radio-label-text-' + name, color: colorMode === 'light' ? 'text.secondary' : 'text.tertiary' }, labelText))),
        React.createElement(RadioGroup, { defaultValue: options[0].value, key: 'radio-group-' + name, name: name, ref: ref, onChange: onChange, onBlur: onBlur, value: value, ...rest },
            React.createElement(Stack, { spacing: groupProps?.spacing || 2, direction: groupProps?.direction || 'row' }, [
                ...options.map((radio, index) => {
                    return (React.createElement(Spacer, { key: 'radio-spacer-' + index },
                        React.createElement(Radio, { my: 3, key: 'radio-spacer-' + index, value: radio.value },
                            React.createElement(Text, { key: 'radioText' + index }, radio.text))));
                })
            ])),
        helperText && !errors[name] && React.createElement(FormHelperText, { key: 'sub-label' + name }, helperText),
        errors[name] && (React.createElement(FormWarning, { key: 'error-label' + name },
            React.createElement(ErrorMessage, { errors: errors, name: name, render: ({ message }) => React.createElement("p", null, message) })))));
};
